module.exports = __webpack_public_path__ + "assets/img_sherry_leheman.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_sherry_leheman.jpg
 ** module id = 132
 ** module chunks = 1
 **/